import { useState } from "react";

import {
  Button,
  ButtonIconWithLabel,
  Icon_Checkmark24,
  Icon_LinkWeb24,
} from "@shapr3d/frontend-lib";
import classNames from "classnames";

import style from "./CopyLinkButton.module.css";

interface CopyLinkButtonProps {
  onCopy?: () => void;
}

export const CopyLinkButton = ({ onCopy }: CopyLinkButtonProps) => {
  const [copySuccessVisible, setCopySuccessVisible] = useState(false);

  const handleCopyClick = () => {
    navigator.clipboard.writeText(`${window.location.origin}${location.pathname}`);
    setCopySuccessVisible(true);
    setTimeout(() => {
      setCopySuccessVisible(false);
    }, 1000);

    onCopy?.();
  };

  return (
    <div className={style.copyLinkContainer}>
      <Button variant="grayscale" onClick={handleCopyClick}>
        <ButtonIconWithLabel icon={<Icon_LinkWeb24 />} label="Copy link" />
      </Button>
      <div className={classNames(style.copySuccessContainer, copySuccessVisible && style.visible)}>
        <Icon_Checkmark24 />
        <span>Copied!</span>
      </div>
    </div>
  );
};
